module.exports = __webpack_public_path__ + "static/media/coliseu_porto_ageas_circo_2018_18.d9bb994f.jpg";